import { render } from "./ClassicCgsDashboard.vue?vue&type=template&id=1fee0064&scoped=true"
import script from "./ClassicCgsDashboard.vue?vue&type=script&lang=js"
export * from "./ClassicCgsDashboard.vue?vue&type=script&lang=js"

import "./ClassicCgsDashboard.vue?vue&type=style&index=0&id=1fee0064&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fee0064"]])

export default __exports__